var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatewayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9899 6.99081L15.7287 16.2521L19.7462 20.2695L24.9899 15.0258L27.9632 17.9991L17.9991 27.9633L8.03497 17.9991L17.9991 8.03497L19.6213 9.65713L23.6388 5.63786L17.9991 0L0 17.9991L17.9991 36L36 17.9991L24.9899 6.99081Z",
    fill: "#007DFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayIcon);
export default __webpack_public_path__ + "static/media/gatewayIcon.34ff0127ea27e25c3af398cb80c7e2d9.svg";
export { ForwardRef as ReactComponent };